import { CREATE_YOUTUBE_VIDEOS_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { videos: {}, errors: null };

export default function ytVideos(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case CREATE_YOUTUBE_VIDEOS_SUCCESS:
      
      const parsedData = JSON.parse(action.payload.data)
      return { ...state, videos: parsedData, errors: null }
    default:
      return state;
  }
}